import { styled, Breakpoints } from '@vw-marketing/us-components';

export const ReviewDataWrapper: any = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  color: #758189;
  height: auto;
  width: 100%;
`;

export const ReplyCommentWrapper: any = styled.div`
  display: flex;
  flex-flow: column;
  border-top: 1px solid #dfe4e8;
  padding-top: 30px;
  margin-top: 30px;
  overflow: hidden;
  height: 100%;
`;
export const ReviewCommentWrapper: any = styled.div`
  display: flex;
  padding-top: 28px;
  overflow: hidden;
  height: auto;
`;

export const ReviewerNameWrapper: any = styled.div``;
export const ReviewerApplyNameWrapper: any = styled.div`
  display: flex;
  align-items: center;
  color: #758189;
  justify-content: space-between;
  height: auto;
`;
export const ViewMoreButtonWrapper: any = styled.div``;

interface StyledOpacityWrapperProps {
  isOpacity?: boolean;
}
export const StyledOpacityWrapper: any = styled.div<StyledOpacityWrapperProps>`
  ${(props: StyledOpacityWrapperProps) =>
    props.isOpacity &&
    ` position: absolute;
    width: calc(100% + 2px);
    height: 100%;
    top: -1px;
    right: -1px;
    background-color: white;
    opacity: 0.48;
    z-index: 1;
  `}
`;

export const ReviewerContainerWrapper: any = styled.div`
  display: grid;
  height: auto;
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  grid-template-columns: 100%;
`;

interface ReviewCardContainerProps {
  containerHeight: boolean;
}
export const ReviewCardContainer: any = styled.div<ReviewCardContainerProps>`
  ${({ containerHeight }: ReviewCardContainerProps) => `
  margin-left: 3px;
  margin-top: 20px;
  border: 1px solid #dfe4e8;
  padding: 30px 20px 33px 20px;
  display: flex;
  flex-flow: column;
  justify-content: stretch;
  height: ${containerHeight ? `515px` : `auto`};
  max-height: ${containerHeight ? `515px` : `auto`};
  min-height: 515px;
  position: relative;
  @media (min-width: ${Breakpoints.b560}px) {
    height: ${containerHeight ? `545px` : `auto`};
    max-height: ${containerHeight ? `545px` : `auto`};
    min-height: 545px;
  }
  @media (min-width: ${Breakpoints.b1280}px) {
    height: ${containerHeight ? `515px` : `auto`};
    max-height: ${containerHeight ? `515px` : `auto`};
    min-height: 515px;
  }
`}
`;

export const ReviewReplyCommentWrapper: any = styled.div`
  display: flex;
  padding-top: 28px;
  overflow: hidden;
  height: 100%;
`;
